{
  "en": {
    "planAnalysisRequests": {
      "retryPlanAnalysisSuccess": "Plan analysis retried successfully.",
      "retryPlanAnalysisError": "Failed to retry plan analysis."
    }
  },
  "fr": {
    "planAnalysisRequests": {
      "retryPlanAnalysisSuccess": "Nouvelle tentative d'analyse du plan réussie.",
      "retryPlanAnalysisError": "Échec de la nouvelle tentative d'analyse du plan."
    }
  },
  "nl": {
    "planAnalysisRequests": {
      "retryPlanAnalysisSuccess": "Opnieuw proberen van planaanalyse is gelukt.",
      "retryPlanAnalysisError": "Mislukt om planaanalyse opnieuw te proberen."
    }
  }
}
